module.exports = __webpack_public_path__ + "img/footer-logo.07e94b0c.png";